<template>
  <div>
    <Header :self="self" />
    <div class="container main">
      <div class="content">
        <h2>Using Quozio</h2>

        <h5>What is Quozio?</h5>
        <p>
          Quozio is an online quote maker that allows you to create beautiful images from your favorite quotes and thoughts. Just load in your quote and author, and Quozio will instantly create dozens of quote images with professional, hand-crafted designs for you to select from. Then the best part: save, download and share your creation on Pinterest, Facebook and Twiiter!
        </p>
        <p>
          Quozio is the fastest and easiest quote generator you'll find, used by millions to turn precious words into shareable images. You can create quotes completely online - there's no software to download or install. And yes, it's free!
        </p>

        <h5>How do I use Quozio?</h5>
        <p>
          Just visit <a href="/">quozio.com</a> and fill in your quote. Or, even faster, <a href="/bookmarklet">get the bookmarklet</a> which lets you instantly create an image out of any text you highlight on a web page.
        <p>
          After you provide your quote, scroll through the various styles and find the one that best matches it. That's it! Create quotes to share and keep in just seconds!
        </p>

        <h5>Can I see some samples?</h5>
        <p>
          Sure. Just <a href="/?quote=Try%20not%20to%20become%20a%20person%20of%20success%2C%20but%20rather%20try%20to%20become%20a%20person%20of%20value.&author=Albert%20Einstein">try it out with a quick example</a>. You don't need to create an account to use Quozio.
        </p>

        <h5>How much does it cost?</h5>
        <p>
          The core features of Quozio - creating and sharing quotes - are free and will always be free. You can get access to additional features such as hundreds of more designs, custom image watermarks and more with <nuxt-link :to="{name: 'get-quozio-pro', params: {ref: 'HTUCA'}}">Quozio Pro</nuxt-link>. If you love Quozio, we'd sure appreciate a <a href="https://www.facebook.com/Quozio/">Facebook like</a>! &#128512;
        </p>

        <h5>Do I need an account?</h5>
        <p>
          No, you don't need an account to use Quozio. No account, email address or sign-up is required. You can create and share as many quote as you'd like free of charge without any need for an account. If you decide to create a free account, we can provide some extra features to you (see below).
        </p>

        <h5>What do I get if I do create a free account?</h5>
        <p>
          If you decide to create a free account on Quozio, we provide a number of additional benefits:
          <ul>
            <li>Save your favorite quotes</li>
            <li>Create boards to organize your saved quotes by topic or category</li>
            <li>Share your profile with your friends so they can browse your saved quotes</li>
            <li>Create private boards for yourself or between groups of friends</li>
            <li>Follow other inspiring users to see what they're posting</li>
            <li>Have others follow the public quotes you are creating</li>
          </ul>
        </p>

        <h5>What do I get with Quozio Pro?</h5>
        <p>
          If you join Quozio Pro, you get access to these premium features:
          <ul>
            <li>Access and use hundreds of additional designs for your quotes</li>
            <li>Add personal, customized watermarks to quotes you create (with your name, website, social media handles, etc.)</li>
            <li>Download high definition, full size images (best quality for printing, embedding into presentations, etc.)</li>
            <li>Create unlimited boards to categorize and save quotes you create</li>
            <li>Premium customer support to help you get the most from Quozio</li>
          </ul>
        </p>
        <p>
          Want to learn more? <nuxt-link :to="{name: 'get-quozio-pro', params: {ref: 'HTWDIG'}}">Check out Quozio Pro</nuxt-link>!
        </p>

        <h5>Have another question or something to share?</h5>
        <p>
          Please <a href="/contact">contact us</a>, we'd love to hear from you!
        </p>

      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  import { mapState } from "vuex";

  export default {
    components: { Header, Footer },
    async asyncData({ store, app }) {
      await store.dispatch("self/get", app.$cookies);
    },
    head() {
      return {
        title: "How to use Quozio",
        meta: [
          { hid: "description", name: "description", content: "How to use Quozio" }
        ]
      }
    },
    methods: {
    },
    computed: {
      ...mapState("self", { self: "self" }),
    },
  };
</script>
